// extracted by mini-css-extract-plugin
module.exports = {"vBlue7":"#613bfe","rating":"RatingTypeSum_rating__1dVMH","name":"RatingTypeSum_name__13AXa","total":"RatingTypeSum_total__38fnI"};